import { defa }     from 'defa-object';
import ControlModel from 'scripts/poppet/control-model';

/**
 * defa.models.GenericState
 * The DEFA GenericState model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );

const apiHost = defa.vars.apiHost;

const api = {
	linkcom     : apiHost + '/linkcom/',
	genericState: '/generic/generic?attrs=vehicleBatteryVoltage,vehicleBatteryLevel',
};

const GenericState = ControlModel.extend( {
	
	url: function () {
		return api.linkcom + this.get( 'id' ) + api.genericState;
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend( {}, ControlModel.prototype.defaults,
		{
			vehicleBatteryVoltage: null,
			vehicleBatteryLevel  : null,
		}
	),
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	parse: function ( response ) {
		if ( response ) {
			response.modelError = null;
			this.receivedData( response );
			channel.request( 'genericStates' ).add( response, { merge: true } );
		}
	},
	
} );

export default GenericState;
